// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const garchomp: PokeData = {
  "id": 445,
  "name": "garchomp",
  "height": 19,
  "weight": 950,
  "base_experience": 270,
  "types": [
    PokeType.DRAGON,
    PokeType.GROUND
  ],
  "api_moves": [
    "sand-attack",
    "tackle",
    "take-down",
    "double-edge",
    "bite",
    "dragon-rage",
    "dig",
    "slash",
    "outrage",
    "sandstorm",
    "dragon-breath",
    "twister",
    "crunch",
    "sand-tomb",
    "dragon-claw",
    "dragon-rush",
    "earth-power",
    "fire-fang",
    "bulldoze",
    "dual-chop"
  ],
  "moves": [
    "tackle",
    "bite",
    "outrage",
    "sandstorm",
    "dragon-breath",
    "crunch",
    "dragon-claw",
    "dragon-rush",
    "earth-power",
    "fire-fang",
    "mud-bomb",
    "magnitude",
    "mud-shot"
  ],
  "evolution_chain": {
    "id": 230,
    "item": null,
    "species": [
      {
        "name": "gible",
        "order": 464,
        "types": [
          PokeType.DRAGON,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "gabite",
        "order": 465,
        "types": [
          PokeType.DRAGON,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 443,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 24,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "garchomp",
        "order": 466,
        "types": [
          PokeType.DRAGON,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 444,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 48,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 120,
    "speed": 123,
    "ability_power": 157
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
